import { useNavigate } from 'react-router-dom'

interface Highlight {
  id: number
  title: string
  description: string
  googledrivelink: string
  image: string
  display_date: string
  stats?: string
}

interface EventHighlightsProps {
  highlights: Highlight[]
}

const EventHighlights = ({ highlights }: EventHighlightsProps) => {
  const navigate = useNavigate()
  return (
    <section className="bg-gray-800 py-16 md:py-24 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="particle-bg"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary-light text-sm md:text-base font-semibold uppercase tracking-wider">
              Event Highlights
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
              Memorable Moments
            </h2>
            {/* <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Relive the magic of our past events and unforgettable performances
            </p> */}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {highlights.map((highlight, index) => (
              <div
                key={highlight.id}
                onClick={() => {
                  navigate(`/events/${highlight.id}`)
                }}
                className="group relative bg-gray-900 rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                style={{
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                {/* Image Container */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={highlight.image}
                    alt={highlight.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                  
                  {/* display_date Badge */}
                  <div className="absolute top-4 right-4 bg-primary-light text-white px-4 py-2 rounded-lg font-bold text-lg shadow-lg">
                    {highlight.display_date}
                  </div>

                  {/* Stats Overlay */}
                  {highlight.stats && (
                    <div className="absolute bottom-4 left-4 bg-black/70 backdrop-blur-sm px-4 py-2 rounded-lg">
                      <p className="text-white font-semibold text-sm">{highlight.stats}</p>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-primary-light transition-colors">
                    {highlight.title}
                  </h3>
                  <p className="text-gray-300 text-sm md:text-base leading-relaxed">
                    {highlight.description}
                  </p>
                </div>

                {/* Hover Effect Glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary-light/0 via-primary-light/0 to-primary-light/0 group-hover:from-primary-light/10 group-hover:via-primary-light/5 group-hover:to-primary-light/10 transition-all duration-500 pointer-events-none"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default EventHighlights

